module.exports = __webpack_public_path__ + "static/media/brave.498c8929.svg";